import ReviewsWidgetModal from './ReviewsWidgetModal'

export default ReviewsWidgetModal
